
import { Button } from "@/components/ui/button";
import { DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FluxoCard, KanbanColumn } from "@/components/solar/kanban/types";
import { CardBasicInfoFields } from "./card-form/CardBasicInfoFields";
import { CardStatusFields } from "./card-form/CardStatusFields";
import { CardAppearanceSettings } from "./card-form/CardAppearanceSettings";
import { cardColors } from "./card-form/CardColorSelector";

interface CardFormProps {
  card: Partial<FluxoCard>;
  onChange: (field: string, value: any) => void;
  onSave: () => void;
  isEditing?: boolean;
  onDelete?: () => void;
  onCancel?: () => void;
  columns?: KanbanColumn[];
}

export const CardForm = ({
  card,
  onChange,
  onSave,
  isEditing = false,
  onDelete,
  onCancel,
  columns = [],
}: CardFormProps) => {
  // Handle double-click on the form to save
  const handleDoubleClick = () => {
    if (isEditing && card.titulo && card.status) {
      onSave();
    }
  };

  return (
    <DialogContent 
      className="sm:max-w-lg max-h-[90vh] overflow-y-auto"
      onDoubleClick={handleDoubleClick}
    >
      <DialogHeader>
        <DialogTitle>{isEditing ? 'Editar Card' : 'Adicionar Novo Card'}</DialogTitle>
        <DialogDescription>
          {isEditing 
            ? 'Atualize as informações do card. Dê um duplo clique para salvar rápido.' 
            : 'Crie um novo card para o fluxo de trabalho.'}
        </DialogDescription>
      </DialogHeader>
      
      <div className="grid gap-4 py-4">
        <CardBasicInfoFields 
          titulo={card.titulo || ""}
          potenciaKwp={card.potenciaKwp || ""}
          valorVenda={String(card.valorVenda || "")}
          valorKit={String(card.valorKit || "")}
          descricao={card.descricao || ""}
          onTituloChange={(value) => onChange('titulo', value)}
          onPotenciaChange={(value) => onChange('potenciaKwp', value)}
          onValorVendaChange={(value) => onChange('valorVenda', value)}
          onValorKitChange={(value) => onChange('valorKit', value)}
          onDescricaoChange={(value) => onChange('descricao', value)}
        />
        
        <CardStatusFields 
          status={card.status || (columns.length > 0 ? columns[0].id : 'lead')}
          prioridade={card.prioridade || 'media'}
          columns={columns}
          onStatusChange={(value) => onChange('status', value)}
          onPriorityChange={(value) => onChange('prioridade', value)}
        />

        <CardAppearanceSettings 
          color={card.cor || "bg-card"}
          perspective={card.perspective || false}
          onColorChange={(value) => onChange('cor', value)}
          onPerspectiveChange={(checked) => onChange('perspective', checked)}
        />
      </div>
      
      <DialogFooter className={isEditing ? "flex justify-between sm:justify-between" : ""}>
        {isEditing && onDelete && (
          <Button 
            variant="destructive" 
            onClick={onDelete}
            className="transition-all duration-200"
          >
            Remover
          </Button>
        )}
        <div className="flex gap-2">
          {onCancel && (
            <Button 
              variant="outline" 
              onClick={onCancel}
              className="transition-all duration-200"
            >
              Cancelar
            </Button>
          )}
          <Button onClick={onSave} className="transition-all duration-200">
            {isEditing ? 'Salvar' : 'Adicionar'}
          </Button>
        </div>
      </DialogFooter>
    </DialogContent>
  );
};
